<template>
  <el-dialog
    class="es-dialog"
    :visible.sync="dialogVisible"
    :center="true"
    :append-to-body="true"
    width="600px"
  >
    <div slot="title" class="dialog-title">
      <span>{{ $t('message.home.selectDeliveryAddress') }}</span>
    </div>
    <div class="address-modal-content dialog-content">
      <div
          :class="{
          'address-active': paySelectAddress.id === item.id,
          item: true,
        }"
          v-for="item in addressList"
          :key="item.id"
          @click="selectAddress(item)"
      >
        <div class="info">
          <span class="name">{{ item.contacts }}</span>
          <span class="mobile">&nbsp;&nbsp;+{{ item.phone }}</span>
          <span v-if="isAddressDefault(item)" class="default-tag">{{
            $t("message.home.defaultAddress")
          }}</span>
        </div>
        <div class="address">
          {{ item.country }} {{ item.province }} {{ item.city }}
          {{ item.address }}
        </div>
      </div>
      <div
          class="item"
          @click="changeAddressView"
      >
        {{$t('message.home.addNewAddress')}}
      </div>
    </div>
    <span slot="footer"></span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

//////////////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////////////

export default {
  name: 'EsPayAddress',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'show',
    event: 'update',
  },
  data() {
    return {
      dialogVisible: false,


//////////////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////////////


    }
  },
  computed: {
    ...mapGetters({
      addressList: 'user/addressList',
      // defaultAddress: 'user/defaultAddress',
      paySelectAddress: 'user/paySelectAddress',
    }),
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('update', newValue)
        if (newValue) {
          this.requestAddressList()
        }
      }
    },
    show(newValue, oldValue) {
      if (newValue !== oldValue) this.dialogVisible = newValue
    },
  },
  mounted() {
    this.dialogVisible = this.show
  },
  methods: {
    ...mapMutations({
      updatePaySelectAddress: 'user/updatePaySelectAddress',
    }),
    ...mapActions({
      requestAddressList: 'user/requestAddressList',
      requestAddressAdd: 'user/requestAddressAdd',
    }),
    isAddressDefault(item) {
      return (
        item &&
        (item.isDefault === true || item.isDefault === 1 || item.use === 1)
      );
    },
    changeAddressView(){
      this.$emit('showAddAddressView')
    },
    selectAddress(item) {
      this.updatePaySelectAddress(item)
      this.dialogVisible = false
    },


//////////////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////////////

  },
}
</script>

<style lang="scss" scoped>
.item {
  width: 100%;
  border: 1px solid var(--color-border);
  padding: 12px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  &:hover {
    border-color: var(--color-main);
  }
  .info {
    margin-bottom: 8px;
  }
  .default-tag {
    margin-left: 8px;
    padding: 0 6px;
    font-size: 12px;
    color: var(--color-main);
    border: 1px solid var(--color-main);
    border-radius: 2px;
  }
}

.address-active {
  border-color: var(--color-main);
}
</style>
